import { TypographyComponent as TypographyElement, Modal } from '@tvg/fuse-design';
import React from 'react';
import styled from 'styled-components';
import IconLocalOffer from '@tvg/fuse-icons/lib/LocalOffer';
import { PromotionVoucher } from '../../../types/Product';

const TypographyWithMargin = styled(TypographyElement)`
  margin-top: var(--spacing-global-space4);
`;

const BulletPointList = styled.ul`
  padding-left: 20px;
  list-style: disc;
  margin-top: var(--spacing-global-space4);
  margin-bottom: var(--spacing-global-space4);
`;

function PercentageAndDeliveryVoucherDialog({
  promotionVoucher: { voucherCode, offerTitle },
  dialogOpen,
  closeDialog,
  modalOfferTerms,
}: {
  promotionVoucher: PromotionVoucher;
  dialogOpen: boolean;
  closeDialog: () => void;
  modalOfferTerms: string;
}) {
  return (
    <Modal
      name="promotion_voucher_dialog"
      open={dialogOpen}
      onClose={closeDialog}
      title={offerTitle}
      headerIcon={<IconLocalOffer />}
      dataTestId="promotion_voucher_dialog"
      srLabelCloseButton="close promotion voucher"
      zIndex="20"
    >
      <TypographyElement type="paragraph" size="m1">
        {modalOfferTerms}
      </TypographyElement>
      <TypographyWithMargin type="paragraph" size="m1">
        {`Just so you know, this offer is open to ALL customers even if you don't have Very Pay. Just shop as you usually
        would and enter ${voucherCode} and we'll do the rest.`}
      </TypographyWithMargin>
      <br />
      <TypographyElement type="heading" size="1">
        Plus more time to pay with Very Pay
      </TypographyElement>
      <TypographyWithMargin type="heading" size="1">
        Pay now
      </TypographyWithMargin>
      <TypographyElement type="paragraph" size="m1">
        You can pay in full today using a credit or debit card.
      </TypographyElement>
      <TypographyWithMargin type="heading" size="1">
        Monthly
      </TypographyWithMargin>
      <TypographyElement type="heading" size="m1">
        You can choose to pay monthly with flexible monthly payments
      </TypographyElement>
      <BulletPointList data-testid="monthly-list">
        <li>You always have the flexibility to pay a monthly amount that suits you.</li>
        <li>
          This must be at least £5 or 6% of your balance. The minimum payment is detailed on your statement. If you pay
          this way you will be charged interest, and it will take you longer to pay off your balance.
        </li>
      </BulletPointList>
      <TypographyElement type="heading" size="1">
        Pay in 3 with Take 3
      </TypographyElement>
      <TypographyElement type="heading" size="m1">
        3 payments, 3 months, pay no interest.
      </TypographyElement>
      <BulletPointList data-testid="pay-list">
        <li>This lets you split the cost of anything over 3 months.</li>
        <li>Plus, you pay nothing for at least 20 days.</li>
        <li>
          If you choose not to make your Take 3 payments, then you&apos;ll pay interest on your balance at your account
          rate.
        </li>
      </BulletPointList>
      <TypographyElement type="heading" size="1">
        Buy Now Pay Later
      </TypographyElement>
      <TypographyElement type="heading" size="m1">
        Shop now and delay payment, subject to your credit and account status.
      </TypographyElement>
      <BulletPointList data-testid="pay-later-list">
        <li>
          BNPL is an interest-bearing option that allows you to delay payments on your purchases for up to 12 months
          depending on how much you spend.
        </li>
        <li>The costs for delivery, installation services and monthly insurance products cannot be placed on BNPL.</li>
        <li>
          If eligible, the delayed payment period and minimum order values to qualify for Buy Now Pay Later will be
          detailed in checkout and are subject to offer.
        </li>
        <li>
          The delayed payment period starts from the date of order (including pre-ordered items and those not ready for
          immediate dispatch).
        </li>
        <li>
          If you choose not to pay the cash price before the end of the delayed payment period a lump sum of compound
          interest will be charged to your account.
        </li>
        <li>
          This will attract interest at your account rate, meaning you will pay interest on interest.{' '}
          <strong>
            This will be included within your account minimum payment request on your monthly statement and cannot be
            repaid using Take 3.
          </strong>
        </li>
        <li>
          Remember, avoid interest by paying the cash price before the end of the delayed payment period, this can be
          done in one full payment or multiple partial payments.
        </li>
      </BulletPointList>
      <br />
      <br />
      <TypographyElement type="heading" size="3">
        Representative Example
      </TypographyElement>
      <TypographyWithMargin type="heading" size="m1">
        This represents a typical cost of using Very Pay: Representative 44.9% APR variable (annual interest rate of
        44.9% variable). A personalised credit limit, typically £1,000. You may be offered other promotional interest
        rates.
      </TypographyWithMargin>
    </Modal>
  );
}

export default PercentageAndDeliveryVoucherDialog;
